export default "__VITE_ASSET__0MACWb1b__"